import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, Input, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatChipSet } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import * as moment from 'moment';
import { MarkdownModule } from 'ngx-markdown';
import { AppPopContentComponent } from 'src/app/shared/services/app-pop-content/app-pop-content.component';
import { SkeletonComponent } from 'src/app/shared/components/ui/skeleton/skeleton.component';
import { Edition } from '../search.dto';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkdownModule, TranslateModule, MatChipsModule, MatIconModule, MatTooltipModule, MatButtonModule, MatChipSet, SkeletonComponent],
  encapsulation: ViewEncapsulation.None,
})
export class SearchResultsComponent {
  private _editions: Edition[] = [];
  groupedEditions: {
    routerLink: string;
    type: string;
    contentRef?: any;
    editions: Edition[];
  }[] = [];

  @Input()
  set editions(value: Edition[]) {
    this._editions = value || [];
    this.groupEditions();
  }

  get editions(): Edition[] {
    return this._editions;
  }

  @Input() finalAIResponse: string = '';
  @Input() temporaryAnswer: string = '';
  @Input() searchType: string = 'vector';
  @Input() loading: boolean = false;

  private groupEditions() {
    const groups: { [key: string]: typeof this.groupedEditions[0] } = {};
    for (const edition of this._editions) {
      const key = edition.routerLink || edition._id;
      if (!groups[key]) {
        groups[key] = {
          routerLink: edition.routerLink || '',
          type: edition.contentRef?.type || '',
          contentRef: edition.contentRef,
          editions: [],
        };
      }
      groups[key].editions.push(edition);
    }
    this.groupedEditions = Object.values(groups);
  }

  @ViewChildren('videoPlayer') videos!: QueryList<ElementRef>;

  expandedEditions = new Set<string>();

  toggleTags(editionId: string): void {
    if (this.expandedEditions.has(editionId)) {
      this.expandedEditions.delete(editionId);
    } else {
      this.expandedEditions.add(editionId);
    }
  }

  isTagsExpanded(editionId: string): boolean {
    return this.expandedEditions.has(editionId);
  }

  private dialog = inject(MatDialog);

  playVideoAt(edition: Edition, timestamp: string) {
    if (edition.type == 'video') {
      this.videos.forEach((video: ElementRef) => video.nativeElement.pause());
      const video: ElementRef = this.videos.find((e) => e.nativeElement.id == edition._id);
      if (video) {
        video.nativeElement.currentTime = moment.duration(timestamp).asSeconds();
        video.nativeElement.play();
      }
    }
  }

  visulizeContent(contentID: string) {
    this.dialog.open(AppPopContentComponent, {
      width: '70vw',
      maxWidth: '80vw',
      data: { contentID },
    });
  }
}
